import { ConfirmationModalBean } from "../components/modal/ConfirmationModalBean";
import { BackendService } from "../services/BackendService";
import { USER_ACC_SEARCHABLEITEMS } from "../services/arsweb/RoutingPaths";
import { CONSOLIDATION_CURRENCY, DEF_CURRENCY } from "../views/dashboard/dashboard";
import { resolveReactCrumbProps, setReactCrumbProps } from "../components/react/AwApplicationHeaderHelpers/AwApplicationHeaderHelpers";

export const CONSOLIDATION_CURRENCY_PARAMS = 'consolidation-currency';
/** @ngInject */
export class CommonViewController {

    constructor($scope, userService, arsMainDependencies) {
        this.$scope = $scope;
        this.ftsMainDependencies = userService.fsMainDependencies;
        this.$rootScope = this.ftsMainDependencies.$rootScope;
        this.log = this.ftsMainDependencies.$log;
        if (!arsMainDependencies) {
            userService.fsMainDependencies.$location.reload();
        }
        this.state = arsMainDependencies.$state;
        this.modal = arsMainDependencies.$mdDialog;
        this.store = arsMainDependencies.store;
        this.cookies = arsMainDependencies.cookies;
        this.translate = this.ftsMainDependencies.$translate;
        this.toast = this.ftsMainDependencies.toast;
        this.sessionPersistance = this.ftsMainDependencies.sessionPersistance;
        this.setReactCrumbProps();
    }

    setReactCrumbProps(entity) {
        setReactCrumbProps(this.$rootScope, resolveReactCrumbProps(this.state.current.name, entity, this.translate.instant));
    }

    showDetailsView(id, detailView) {
        if (detailView === '') {
            return;
        }
        this.state.go(detailView, { id: id });
    }

    showChildDetailsView(id, parentId, detailView) {
        this.state.go(detailView, { id: id, parentID: parentId });
    }

    openModal(ev, stateName, modalTarget) {
        const nextState = this.state.get(stateName);
        this.state._params = nextState.params;
        this.open(nextState, modalTarget);
    }

    openModalWithParams(ev, stateName, modalTarget, params) {
        const nextState = this.state.get(stateName);
        this.state._params = nextState.params;
        Object.keys(params).forEach(key => {
            this.state._params[key] = params[key];
        });
        this.open(nextState, modalTarget);
    }

    openExistingInModal(id, stateName, modalTarget) {
        const nextState = this.state.get(stateName);
        this.state._params = nextState.params;
        this.state._params.id = id;
        this.open(nextState, modalTarget);
    }

    openModalReact(stateName) {
        const nextState = this.state.get(stateName);
        this.state._params = nextState.params;
        this.open(nextState);
    }

    open(nextState, modalTarget) {
        this.modal.show({
            templateUrl: nextState.templateUrl,
            controller: nextState.controller,
            controllerAs: nextState.controllerAs,
            scope: this.$scope,
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            openFrom: modalTarget,
            closeTo: modalTarget
        }).finally(() => {
            // calls on ESC, need to reload the state
            this.modal.cancel();
            this.state.reload();
        });
    }

    isUndefined(item) {
        return typeof item === 'undefined';
    }

    errorPop(toasterTitle, toasterBody) {
        this.toast.errorPop(toasterTitle, toasterBody);
    }

    successPop(toasterBody) {
        this.toast.successPop(toasterBody);
    }

    infoPop(toasterBody) {
        this.toast.infoPop(toasterBody);
    }

    isFromBiggerThanTo(dtmfrom, dtmto) {
        return new Date(dtmfrom).getTime() > new Date(dtmto).getTime();
    }

    confirm(confBean) {

        return this.modal.show({
            templateUrl: 'app/components/modal/confirmation-modal.html',
            controller: 'ConfirmationModalController',
            controllerAs: 'confirmationModalController',
            size: 'md',
            backdrop: 'static',
            keyboard: false,
            multiple: true,
            resolve: { confirmationModalBean: () => confBean }
        });
    }

    confirmAsynch() {
        return this.confirm(
          new ConfirmationModalBean(this.translate.instant('CONFIRM_DOC_ASYNCH'), 'DOWNLOADS_ARCHIVE'));
    }

    getUserAccountBackendService(userService, sort) {
        const backendService = new BackendService(userService, USER_ACC_SEARCHABLEITEMS);
        backendService.service.config.params.dateFilter = this.ftsMainDependencies.$rootScope.dateFilter;
        this.consolidationCurrency(backendService);
        backendService.service.config.params.sort = sort;
        backendService.resetPaging(100);
        return backendService;
    }

    consolidationCurrency(backendService) {
        const rootScope = this.ftsMainDependencies.$rootScope;
        if (rootScope.consolidationCurrency) {
            backendService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = rootScope.consolidationCurrency.code ?
                rootScope.consolidationCurrency.code : rootScope.consolidationCurrency;
        } else if(this.sessionPersistance.promise){
            // read from  storage or default
            this.sessionPersistance.promise.then(() => {
                this.ftsMainDependencies.$rootScope.consolidationCurrency = this.sessionPersistance.get(CONSOLIDATION_CURRENCY) || DEF_CURRENCY;
                backendService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = this.ftsMainDependencies.$rootScope.consolidationCurrency.code ?
                    this.ftsMainDependencies.$rootScope.consolidationCurrency.code : this.ftsMainDependencies.$rootScope.consolidationCurrency;
            });
        }
    }
}
